import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Modal } from '../elements-modal/modal';
import CancelBookingContainer from '../app-main/containers/CancelBookingContainer';
import CancellationSummaryContainer from '../app-main/containers/CancellationSummaryContainer';

export class CancelBookingIOSModal extends React.Component {
  constructor (props) {
    super(props);

    this.renderBody = this.renderBody.bind(this);
  }

  closeModal () {
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-container'));
    $('#modal-container').modal('hide');
  }

  scrollTopIOS () {
    const modal = document.getElementById('cancel-booking-form-modal');
    if (modal) {
      modal.scrollTo(0, 0);
    }
  }

  renderBody () {
    const { customCb, summary, profile, bookingID } = this.props;
    const accessToken = PSSessions.Cookies('PSAccess');

    if (summary) {
      return (
        <CancellationSummaryContainer
          iosBookingId={bookingID}
          accessToken={accessToken}
          profile={profile}
          closeIOSModal={this.closeModal}
        />
      );
    }

    return (
      <CancelBookingContainer
        accessToken={accessToken}
        ssoID={profile.SSOid}
        iosBookingId={bookingID}
        closeIOSModal={this.closeModal}
        finalCb={customCb}
        cancelAction={this.closeModal}
        scrollTopIOS={this.scrollTopIOS}
      />
    );
  }

  render () {
    return (
      <Modal
        show
        addCloseIcon={false}
        modalID="cancel-booking-form-modal"
        modalSize="lg-size"
        modalType="standard"
        modalClass="cancel-booking-form-modal"
        body={this.renderBody()}
      />
    );
  }
}


CancelBookingIOSModal.propTypes = {
  bookingID: PropTypes.string,
  customCb: PropTypes.func,
  summary: PropTypes.bool,
  profile: PropTypes.object
};
